<div class="side-detail-container">
  <h3>
    <mat-icon>location_on</mat-icon> ข้อมูลจุดบริการ
  </h3>
  <ng-container *ngIf="service">
    <h4>ข้อมูลทั่วไป</h4>
    <app-modal-input inLabel="ชื่อจุดบริการ" [inF]="fg.get('name')" (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>ชื่อจุดบริการ</mat-label>
          <input matInput placeholder="ชื่อจุดบริการที่ใช้ในการแสดงผล" [formControl]="fg.get('name')" required>
          <mat-error>{{ e.addServiceRequiredName }}</mat-error>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <app-modal-input inLabel="ไอดีจุดบริการ" [inF]="fg.get('displayId')" (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>ไอดีุดบริการ</mat-label>
          <input matInput placeholder="ไอดีจุดบริการที่ใช้ในการแสดงผล" [formControl]="fg.get('displayId')" required>
          <mat-error>{{ e.addServiceRequiredDisplayId }}</mat-error>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <app-modal-input inLabel="พิกัดจุดบริการ" [inF]="fg.get('latlong')" (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>พิกัดจุดบริการ</mat-label>
          <input matInput placeholder="ละติจูด,ลองจิจูด" [formControl]="fg.get('latlong')" required>
          <mat-error>{{ e.addServicePatternLatLong }}</mat-error>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <app-modal-input inLabel="รัศมีในการ Check-in ( กิโลเมตร )" [inF]="fg.get('radius')" (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>รัศมีในการ Check-in</mat-label>
          <input matInput placeholder="2.0" [formControl]="fg.get('radius')" required>
          <mat-error>{{ e.addServicePatternRadius }}</mat-error>
          <span matSuffix>กิโลเมตร</span>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <h4>สถานะจุดบริการ</h4>
    <mat-slide-toggle #slide class="radio-label-fill" labelPosition="before" color="primary"
      [(ngModel)]="service.isEnabled" (change)="confirmEnableChanged($event)">
      <span *ngIf="service.isEnabled" class="enabled"> เปิดระบบหลังบ้าน</span>
      <span *ngIf="!service.isEnabled" class="disabled"> ปิดระบบหลังบ้าน</span>
    </mat-slide-toggle>
    <mat-slide-toggle #slide class="radio-label-fill" labelPosition="before" color="primary"
      [(ngModel)]="service.isShown" (change)="confirmEnableChangedShowInApp($event)">
      <span *ngIf="service.isShown" class="enabled"> แสดงจุดบริการในแอพพลิเคชั่น</span>
      <span *ngIf="!service.isShown" class="disabled"> ไม่แสดงจุดบริการในแอพพลิเคชั่น</span>
    </mat-slide-toggle>
    <br>
    <h4>วันที่ปิดบริการ</h4>
    <div>
      <div class="holiday-label" (click)="openDateDialog()">
        <div>
          <span class="info-green" *ngIf="service.openOnWeekends">ไม่หยุดวันเสาร์อาทิตย์</span>
          <span class="info-blue" *ngIf="!service.openOnWeekends">หยุดทุกวันเสาร์อาทิตย์</span>
          จำนวนวันที่หยุดในโอกาสพิเศษ <span class="info-blue"> {{ service.holidays.length }} </span> วัน
        </div>

        <div class="flex-spacer"></div>
        <button color="primary" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>
    <!-- <input class="not-display" [matDatepicker]="picker">
      <button mat-button (click)="picker.open()">
        <mat-icon>add</mat-icon> เพิ่มวันหยุด
      </button>
      <button mat-button class="long-button" (click)="addGoogleHolidays()">
        <mat-icon>calendar_today</mat-icon> เพิ่มวันหยุดตามปีปฏิทิน
      </button>
      <mat-datepicker #picker></mat-datepicker> -->
    <ng-container *ngIf="service.holidays.length > 0">
      รายการวันที่หยุดให้บริการ:
      <mat-accordion class="holiday-panel" [displayMode]="'flat'">
        <ng-container *ngFor="let key of holidayKeys">
          <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header class="right-aligned-header" [collapsedHeight]="'32px'"
              [expandedHeight]="'32px'">
              <mat-panel-title>
                {{ key }}
              </mat-panel-title>
              <mat-panel-description class="right-aligned">
                {{ holidayGroups[key].length }} วัน
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-list dense class="holiday-list">
              <mat-divider></mat-divider>
              <ng-container *ngFor="let date of holidayGroups[key]; let i=index;">
                <mat-divider></mat-divider>
                <mat-list-item>
                  <div class="holiday-date">{{ formatDate(date.date) }}</div>
                  <div>({{ date.name }})</div>
                </mat-list-item>
              </ng-container>
            </mat-list>
          </mat-expansion-panel>
          <mat-divider></mat-divider>
        </ng-container>
      </mat-accordion>
    </ng-container>
    <br>
    <h4>ประเภทของคิว</h4>
    <ng-container *ngIf="service.queueTypes; else noQueueType">
      <div>
        ประเภทคิวที่มี
        <button class="mid-button" mat-button color="primary" (click)="openQueueTypeDialog(null, -1)">
          <mat-icon>add</mat-icon>เพิ่มประเภทคิว
        </button>
      </div>
      <div>
        <mat-list dense class="qtype-list">
          <ng-container *ngFor="let qtype of service.queueTypes; let i = index">
            <mat-list-item [class.online]="qtype.isOnlineBookingAllowed">
              <div>
                คิวประเภทที่ <span class="info-blue">{{ qtype.queueTypeId }}</span>
                ช่วงหมายเลข
                <span class="info-blue">{{ qtype.queueTypePrefix }}</span>
                <span class="info-blue">{{ qtype.initialQueueNumber }}</span> -
                <span class="info-blue">{{ qtype.queueTypePrefix }}</span>
                <span class="info-blue">{{ qtype.endQueueNumber }}</span>
                <ng-container *ngIf="! qtype.isOnlineBookingAllowed">
                  <br>
                  &nbsp; &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp; &nbsp;ช่วงหมายเลขคิวด่วน
                  <span class="info-red" *ngIf="!qtype.fastTrackEndQueueNumber || !qtype.fastTrackInitialQueueNumber else fastTrackQueue">: ไม่มีการตั้งค่า </span>
                  <ng-template #fastTrackQueue>
                    <span class="info-blue">
                      <span class="info-blue">{{ qtype.queueTypePrefix }}</span>
                      {{ qtype.fastTrackInitialQueueNumber }}</span> -
                      <span class="info-blue">{{ qtype.queueTypePrefix }}</span>
                      <span class="info-blue">{{ qtype.fastTrackEndQueueNumber }}</span>
                  </ng-template>

                </ng-container>
                <!-- <ng-container *ngIf="i === 0"> -->
                  <!-- <ng-container *ngIf="qtype.isOnlineBookingAllowed; else onlineNotAllowed"> -->
                  <ng-container *ngIf="qtype.isOnlineBookingAllowed">
                    <br>
                    จองคิว <span class="info-green">ออนไลน์ได้</span> สูงสุด <span class="info-blue">{{ qtype.obMaxReservedQueues }}</span> คิวทุก ๆ ครึ่งชั่วโมง
                    <br>
                    ช่วงเวลาที่เปิดจอง <span class="info-blue"> {{qtype.obTimeslotSummary}} </span>
                  </ng-container>
                  <!-- <ng-template #onlineNotAllowed>
                    <br>
                    จองคิว <span class="info-red">ออนไลน์ไม่เปิดใช้งาน</span>
                    <br>
                  </ng-template> -->
                <!-- </ng-container> -->

              </div>
              <div class="flex-spacer"></div>
              <button mat-icon-button color="primary" (click)="openQueueTypeDialog(qtype, i)" >
                <mat-icon>edit</mat-icon>
              </button>
              <mat-divider></mat-divider>
            </mat-list-item>
          </ng-container>
        </mat-list>
      </div>
    </ng-container>

    <ng-template #noQueueType>
      <div>
        ยังไม่มีประเภทของคิว
      <button class="mid-button" mat-button color="primary" (click)="openQueueTypeDialog(null, -1)">
        <mat-icon>add</mat-icon>เพิ่มประเภทคิว
      </button>
      </div>
    </ng-template>
    <!-- <h4>การจองคิวออนไลน์</h4>
    <app-modal-input inLabel="จำนวนคิวในแต่ละช่วงเวลา" [inF]="fg.get('maxReservedQueues')"
      (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>จำนวนคิวในแต่ละช่วงเวลา</mat-label>
          <input matInput placeholder="จำนวนคิวในแต่ละช่วงเวลา" [formControl]="fg.get('maxReservedQueues')" required>
          <mat-error>{{ e.editServiceNumReservedQueues }}</mat-error>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <div class="timeslot-container">
      <mat-form-field class="static-form" (click)="openTimeslotDialog()">
        <mat-label>ช่วงเวลาที่เปิดจอง</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
          placeholder="ช่วงเวลาที่เปิดจอง" [value]="service.timeslotSummary" readonly>
        </textarea>
      </mat-form-field>
      <div class="flex-spacer"></div>
      <button mat-icon-button (click)="openTimeslotDialog()">
        <mat-icon color="primary">edit</mat-icon>
      </button>
    </div> -->
    <br>

    <h4>ขั้นตอนการรับบริการ</h4>
    <div>
      <div class="holiday-label" (click)="openInstructionDialog()">
        <div *ngIf="service.instructions && service.instructions.length > 0 else noInstruction">
          ขั้นตอนการรับบริการของจุดให้บริการนี้
        </div>
        <ng-template #noInstruction>
          <span class="info-red">ยังไม่มีการตั้งค่า </span> &nbsp; (ไม่แสดง)
        </ng-template>
        <div class="flex-spacer"></div>
        <button color="primary" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
      </div>
      <ol class="instruction-list" *ngIf="service.instructions && service.instructions.length > 0">
        <li *ngFor="let item of service.instructions">{{ item }}</li>
      </ol>
    </div>
    <br>

    <h4>รูปแบบการแจ้งเตือนตามคิว</h4>
    <app-modal-input inLabel="จำนวนคิวที่ต้องการแจ้งเตือนล่วงหน้า" [inF]="fg.get('numQueuesToNotify')"
      (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>จำนวนคิวที่ต้องการแจ้งเตือนล่วงหน้า</mat-label>
          <input matInput type="number" placeholder="" [formControl]="fg.get('numQueuesToNotify')" required>
          <mat-error *ngIf="fg.get('numQueuesToNotify').hasError('required')">{{ e.addServiceRequiredNumQueues }}
          </mat-error>
          <mat-error *ngIf="fg.get('numQueuesToNotify').hasError('pattern')">{{ e.addServiceMinNumQueues }}</mat-error>
          <mat-error *ngIf="fg.get('numQueuesToNotify').hasError('min')">{{ e.addServiceMinNumQueues }}</mat-error>
        </mat-form-field>

      </ng-template>
    </app-modal-input>
    <!-- <div style="display: flex;">
      <mat-label>จำนวนสถานะคิว</mat-label>
      <div class="flex-spacer"></div>
      <mat-radio-group [(value)]="service.queueStatuses.length" (change)="numStatusesChanged($event)">
        <mat-radio-button #sixStatusRadio [value]="6">6 สถานะ&nbsp;&nbsp;&nbsp;</mat-radio-button>
        <mat-radio-button #sevenStatusRadio [value]="7">7 สถานะ&nbsp;&nbsp;</mat-radio-button>
      </mat-radio-group>
    </div> -->
    <!-- <br> -->
    <label>การแจ้งเตือนของสถานะ</label>
    <div class="indent" *ngFor="let status of service.queueStatuses; let i = index">
      <!-- XXX: A HACK TO INCLUDE ONLY SOME QUEUE STATUSES -->
      <ng-container *ngIf="status.isEnabled">
        <label>{{status.name}}</label>
        <!-- <div class="indent"> -->
        <!-- <app-modal-input
                inLabel="ข่้อความแจ้งเตือน"
                [inValue]="status.message"
                (outValue)="editServiceMessage($event, i)">
              <ng-template>
                <mat-form-field>
                  <mat-label>ข้อความแจ้งเตือนของ {{ status.name }}</mat-label>
                  <input
                      matInput
                      [placeholder]="'ข้อความแจ้งเตือนของ ' + status.name"
                      [(ngModel)]="status.message">
                </mat-form-field>
              </ng-template>
            </app-modal-input> -->
        <!-- <div> -->
        <mat-slide-toggle class="radio-label-fill" labelPosition="before" color="primary"
          [(ngModel)]="status.shouldNotify" (change)="confirmNotifyChanged($event, i)">
          <span *ngIf="status.shouldNotify" class="enabled"> เปิดการแจ้งเตือน</span>
          <span *ngIf="!status.shouldNotify" class="disabled"> ปิดการแจ้งเตือน</span>
        </mat-slide-toggle>
        <!-- </div> -->
        <!-- </div> -->
        <br>
        <mat-divider></mat-divider>
      </ng-container>

    </div>
    <br>

    <h4>เอกสารการขอความยินยอม</h4>
    <mat-nav-list dense class="consent-list">
      <mat-list-item *ngFor="let key of sortedConsentKeys"
          (click)="openConsentDialog(service.consents[key])">
        {{ formatConsent(service.consents[key]) }}
        <div class="flex-spacer"></div>
        <mat-icon
          *ngIf="(!service.consents[key].activeDatetime) else readOnlyIcon"
          color="primary">edit</mat-icon>
        <ng-template #readOnlyIcon>
          <mat-icon color="primary">pageview</mat-icon>
        </ng-template>
      </mat-list-item>
    </mat-nav-list>
    <br>
    <div class="flex-spacer"></div>
    <h4>ลบจุดบริการ</h4>
    <div class="text-center">
      <button class="full-button" mat-stroked-button color="warn" (click)="confirmDeleteDialog()">
        ลบจุดบริการ
      </button>
    </div>
  </ng-container>
</div>
